import { createContext, useContext } from "react";

/**
 * App-wide imperative commands, provided by AppLayout so any component
 * (sidebar, pages, keyboard shortcuts) can trigger them. Defaults are no-ops
 * so consumers rendered outside the provider (e.g. the admin shell) are safe.
 */
export interface AppCommands {
  /** Open the global "create link" modal. */
  openCreateLink: () => void;
  /** Open the keyboard-shortcuts help dialog. */
  openShortcutsHelp: () => void;
}

const noop = () => {};

export const CommandsContext = createContext<AppCommands>({
  openCreateLink: noop,
  openShortcutsHelp: noop,
});

export const useCommands = (): AppCommands => useContext(CommandsContext);